module.exports = __WEBPACK_EXTERNAL_MODULE_106__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/message"
// module id = 106
// module chunks = 0 2